export const customerLicenceTypeSelector = (state) => state.account.customer.licence.type;
export const NLiCassiePQuoteFSelector = (state) =>
  state.quote.licence.cassieType === 'P' &&
  (state.quote.licence.type === 'uk_manual' || state.quote.licence.type === 'uk_auto') &&
  !state.account.login.loggedIn;
export const statedTestPassDate = (state) => {
  const testPassDate = state.account.customer.statedTestPassDate;
  return testPassDate || null;
};
